import React, { useEffect, useState, useContext } from "react";
import { MyContext } from "../../../MyContext";
import { toast } from "react-toastify";

import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Loading from "../../pages/Loading";
import { useSession } from "../../session/Context";
import { ConnectingAirportsOutlined } from "@mui/icons-material";
import { AnyMxRecord } from "dns";

import API from "../../Api";
import SingleCreateCredential from "./Single";
import MultiCreateCredential from "./Multi";

let serverUrl = window.location.origin;

const { palette } = createTheme();
const theme = createTheme({
  palette: {
    secondary: {
      main: "#FF297F",
    },
    primary: {
      main: "#231f20",
    },
  },
  typography: {
    fontFamily: "Saira",
  },
});


export default function CreateCredential() {
  const { brand } = useSession();

  const [scopes, setScopes] = useState<any>();

  // Get credential types
  useEffect(() => {
    API(
      "/api/v1/brand" + (brand == "" ? "/root" : "/" + brand) + "/factory"
    ).then((response) => {
      setScopes(response.scope);
    });
  }, []);

  const { onPage, setOnPage } = useContext(MyContext)!;
  useEffect(() => {
    setOnPage(window.location.pathname.substring(1));
  }, []);

  const [loading, setLoading] = useState(true);

  const [value, setValue] = React.useState("1");

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const tabPanelStyle = {
    padding: "0px",
    marginTop: "20px",
  };

  React.useEffect(() => {
    API(
      "/api/v1/brand" + (brand == "" ? "/root" : "/" + brand) + "/factory"
    ).then((response) => {
      setScopes(response.scope);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2>Issue Credential</h2>
        </div>
      </div>

      <div className="col-content">
        <div className="notifications-container">
          <div className="messages  no-mobile-pro"></div>
          {loading && <Loading />}
          {!loading && (
            <ThemeProvider theme={theme}>
              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                  <Box>
                    <TabList
                      value={value}
                      onChange={handleChange}
                      sx={{
                        "& .css-9zg40m-MuiButtonBase-root-MuiTab-root": {
                          padding: 0,
                          marginRight: "20px",
                        },
                        "& .MuiTab-root.Mui-selected": {
                          color: "#231f20",
                        },
                        "& .MuiTab-textColorSecondary": {
                          color: "#CECECE",
                        },
                      }}
                      textColor="secondary"
                      indicatorColor="secondary"
                      aria-label="secondary tabs example"
                    >
                      <Tab label={"Single credential"} value="1" />
                      <Tab label={"Multiple credentials"} value="2" />
                    </TabList>
                  </Box>

                  <TabPanel sx={tabPanelStyle} value="1">
                    <SingleCreateCredential
                      scope={scopes}
                    />
                  </TabPanel>
                  <TabPanel sx={tabPanelStyle} value="2">
                    <MultiCreateCredential
                      scope={scopes}
                    />
                  </TabPanel>
                </TabContext>
              </Box>
            </ThemeProvider>
          )}
        </div>
      </div>
    </>
  );
}
